import { notEnoughPermissionText } from 'owa-locstrings/lib/strings/notenoughpermissiontext.locstring.json';
import { folderWithNameAlreadyExists } from './newFolder.locstring.json';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import loc from 'owa-localize';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderStore, {
    folderHasChildWithName,
    FolderStore,
    createNewFolderService,
} from 'owa-folders';
import { confirm } from 'owa-confirm-dialog';
import { logUsage } from 'owa-analytics';
import { FolderTextFieldViewState } from '../store/schema/FolderTextFieldViewState';
import { action, select } from 'satcheljs/lib/legacy';
import viewStateStore from '../store/store';
import { showErrorMessage, lazyDismissMailFolderTextField } from 'owa-mail-folder-store';
import ResponseClass from 'owa-service/lib/contract/ResponseClass';
import { onNewFolderSuccess } from './onNewFolder';

const SUCCESS: ResponseClass = 'Success';
const ERROR: ResponseClass = 'Error';
const ACCESS_DENIED_RESPONSE_CODE = 'ErrorAccessDenied';

export interface NewFolderState {
    folderStore?: FolderStore;
    viewState?: FolderTextFieldViewState;
}

export let createNewFolder = select<NewFolderState>({
    folderStore: () => folderStore,
})(function createNewFolder(
    displayName: string,
    parentFolderId: string | DistinguishedFolderIdName,
    state?: NewFolderState
): Promise<string> {
    displayName = (displayName || '').trim(); // Do not allow whitespaces.

    // TODO: Task 522 - Implement "provisional folder" logic so that we don't need to wait for the server
    //   response before rendering the folder locally.
    if (displayName) {
        if (folderHasChildWithName(state.folderStore, displayName, parentFolderId)) {
            confirm(
                null,
                loc(folderWithNameAlreadyExists),
                false, // resolveImmediately
                { hideCancelButton: true }
            );
            return Promise.resolve('');
        } else {
            logUsage('TnS_CreateFolder');
            return createNewFolderService(parentFolderId, displayName).then(
                (responseMessage: FolderInfoResponseMessage) => {
                    if (responseMessage.ResponseClass === SUCCESS) {
                        onNewFolderSuccess(responseMessage.Folders[0], parentFolderId, displayName);
                        return responseMessage.Folders[0].FolderId.Id;
                    } else if (
                        responseMessage.ResponseClass === ERROR &&
                        responseMessage.ResponseCode === ACCESS_DENIED_RESPONSE_CODE
                    ) {
                        showErrorMessage(
                            loc(cantCompleteRequestText),
                            loc(notEnoughPermissionText)
                        );
                        return '';
                    } else {
                        throw new Error(responseMessage.MessageText);
                    }
                }
            );
        }
    } else {
        // No-op if there is no display name specified
        return Promise.resolve('');
    }
});

export let createNewFolderFromNewFolderTextField = select<NewFolderState>({
    viewState: () => viewStateStore.folderTextFieldViewState,
})(
    action('createNewFolderFromNewFolderTextField')(function createNewFolderFromNewFolderTextField(
        displayName: string,
        state?: NewFolderState
    ) {
        createNewFolder(displayName, state.viewState.folderId);
        lazyDismissMailFolderTextField.importAndExecute();
    })
);
